import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import store from 'store';
import theme from 'themes';

interface PortalProps {
  id: string;
  content: JSX.Element;
}

export class Portal extends Component<PortalProps> {

  portalRoot?: HTMLElement;
  el = document.createElement('div');

  render() {
    return null;
  }
  
  componentDidMount() {
    const { id } = this.props;
    let p = id && document.getElementById(id);
    if (!p) {
      p = document.createElement('div');
      p.id = id;
      if (document.body) {
        document.body.appendChild(p);
      }
    }
    this.portalRoot = p;
    p.appendChild(this.el);
    this.componentDidUpdate();
  }

  componentWillUnmount() {
    try {
      if (this.el) {
        ReactDOM.unmountComponentAtNode(this.el);
        if (this.portalRoot && this.el.parentNode === this.portalRoot) {
          this.portalRoot.removeChild(this.el);
        }
        if (
          this.portalRoot &&
          this.portalRoot.parentNode &&
          this.portalRoot.childNodes.length === 0
        ) {
          this.portalRoot.parentNode.removeChild(this.portalRoot);
        }
      }
    } catch (err) {
      console.warn('Portal cleanup warning:', err);
    }
  }

  componentDidUpdate() {
    const { content } = this.props;
    ReactDOM.render(
      <Provider store={store}>
        <ThemeProvider theme={theme}>{content}</ThemeProvider>
      </Provider>,
      this.el
    );
  }
}